import { Grid } from "@material-ui/core";
import React from "react";
import { Bar } from "react-chartjs-2";

export default class App extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const state = {
      labels: this.props.label,
      datasets: [
        {
          label: "Joined",
          backgroundColor: "#41FFAF",
          borderColor: "#20829A",
          borderWidth: 1,
          //stack: 1,
          hoverBackgroundColor: "rgba(255,99,132,0.4)",
          hoverBorderColor: "rgba(255,99,132,1)",
          data: this.props.joined,
        },
        {
          label: "Visited",
          backgroundColor: "#E7FC2B",
          borderColor: "##8C9467",
          borderWidth: 1,
          //stack: 1,
          hoverBackgroundColor: "rgba(255,99,132,0.4)",
          hoverBorderColor: "rgba(255,99,132,1)",
          data: this.props.visited,
        },

        {
          label: "Cancelled",
          backgroundColor: "#A096FC",
          borderColor: "#3865A0",
          borderWidth: 1,
          //stack: 1,
          hoverBackgroundColor: "rgba(255,99,132,0.4)",
          hoverBorderColor: "rgba(255,99,132,1)",
          data: this.props.cancelled,
        },
        {
          label: "Not visited",
          backgroundColor: "#FFB18C",
          borderColor: "#8B486E",
          borderWidth: 1,
          //stack: 1,
          hoverBackgroundColor: "rgba(255,99,132,0.4)",
          hoverBorderColor: "rgba(255,99,132,1)",
          data: this.props.notVisited,
        },
      ],
    };
    return (
      <Grid container >
        <Bar
          data={state}
          options={{
            responsive: true,
            legend: {
              display: true,
              position: "bottom",
            },
            type: "bar",
            
          }}
        />
      </Grid>
    );
  }
}
